import { render } from "./threeDViewer.vue?vue&type=template&id=07c02522"
import script from "./threeDViewer.vue?vue&type=script&lang=js"
export * from "./threeDViewer.vue?vue&type=script&lang=js"

import "../style/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__